"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _Spinner = _interopRequireDefault(require("../../resources/images/Spinner.svg"));
var _spinner = require("../spinner/spinner");
var _Alert = require("../alert/Alert");
var _Icon = require("../svg/Icon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var largeScreen = 768;
var defaultProps = {
  dropDownState: 'closed'
};
var Button = exports.Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);
  var _super = _createSuper(Button);
  function Button(props) {
    var _this;
    _classCallCheck(this, Button);
    _this = _super.call(this, props);
    _this.state = {
      smallScreenClass: ''
    };
    return _this;
  }
  _createClass(Button, [{
    key: "updateDimensions",
    value: function updateDimensions() {
      var smallScreenClass = '';
      var windowInnerWidth = window.innerWidth;
      if (windowInnerWidth < largeScreen) {
        smallScreenClass = 'tl-button-mobile';
      }
      this.setState({
        smallScreenClass: smallScreenClass
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions.bind(this));
    }
  }, {
    key: "iconColorFinder",
    value: function iconColorFinder(state) {
      var iconColorCustom = "tl-button-svg-default";
      if (state === 'disabled' || this.props.disabled) {
        iconColorCustom = "tl-button-svg-default tl-button-icon-color-Disabled";
      } else if (state === 'warning') {
        iconColorCustom = "tl-button-svg-default tl-button-icon-color-Warning";
      } else {
        iconColorCustom = "tl-button-svg-default tl-button-icon-color-Active";
      }
      return iconColorCustom;
    }
  }, {
    key: "getButtonType",
    value: function getButtonType(type) {
      var buttonType = type;
      if (type === 'dropdownButton' || type === 'dropdown') {
        buttonType = 'button';
      } else if (type === 'dropdownButtonPg') {
        buttonType = 'button';
      } else {
        buttonType = type;
      }
      return buttonType;
    }
  }, {
    key: "createButton",
    value: function createButton(buttonInnerContent) {
      var _this$props = this.props,
        ariaAttributes = _this$props.ariaAttributes,
        role = _this$props.role;
      var buttonClass = this.getButton(this.props.variant, this.props.state);
      var customWidth = this.props.width ? this.props.width : '';
      var customHeight = this.props.height ? this.props.height : '';
      var customStyle = {
        minWidth: customWidth,
        height: customHeight
      };
      var buttonType = typeof this.props.type === "undefined" ? 'button' : this.getButtonType(this.props.type);
      if (!this.props.state || this.props.state === 'app' || this.props.state === 'warning') {
        var buttonRender = /*#__PURE__*/_react.default.createElement("button", _extends({
          className: buttonClass,
          disabled: this.props.disabled,
          onClick: this.props.onClick,
          name: this.props.name,
          id: this.props.id,
          style: customStyle,
          type: buttonType,
          onMouseEnter: this.props.onMouseEnter,
          onMouseLeave: this.props.onMouseLeave,
          title: this.props.title,
          role: role
        }, ariaAttributes), buttonInnerContent);
        return buttonRender;
      } else {
        var _buttonRender = /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'inline-flex',
            height: this.props.height
          },
          className: 'tl-button-status-' + this.props.state
        }, buttonInnerContent);
        return _buttonRender;
      }
    }
  }, {
    key: "getButtonInnerContent",
    value: function getButtonInnerContent() {
      var buttonInnerContent;
      var iconColorCustom = this.iconColorFinder(this.props.state);
      var primaryIcon = "icon-system-arrow";
      var buttonText = this.props.label ? this.props.label : this.props.children;
      var variantType = this.props.variant ? this.props.variant : 'super';
      switch (variantType) {
        case 'super':
          if (this.props.icon) {
            buttonInnerContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttonText, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon,
              className: iconColorCustom
            })));
            break;
          } else if (this.props.state === 'loading') {
            buttonInnerContent = /*#__PURE__*/_react.default.createElement("img", {
              className: "tl-button-text-spinner",
              src: _Spinner.default,
              alt: ""
            });
            break;
          } else {
            buttonInnerContent = buttonText;
            break;
          }
        case 'emphasis':
          if (this.props.iconPosition === 'left') {
            var buttonClass = this.state.smallScreenClass ? ' ' + this.state.smallScreenClass : '';
            buttonInnerContent = buttonClass ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon,
              className: iconColorCustom
            }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon'
            }, " ", /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              className: iconColorCustom,
              name: this.props.icon
            })), buttonText);
            break;
          } else {
            buttonInnerContent = buttonText;
            break;
          }
        case 'primary':
          if (this.props.type === 'dropdownButton') {
            buttonInnerContent = this.props.icon ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.icon ? /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon tl-bd-icon-left'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon,
              className: iconColorCustom
            })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), buttonText, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon tl-bd-icon-right'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: 'icon-system-chevron-up',
              className: iconColorCustom + ' tl-bd-svg-right toggle-down',
              attributes: {
                id: this.props.name + "-svg"
              }
            }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttonText);
          } else if (this.props.type === 'dropdown') {
            buttonInnerContent = /*#__PURE__*/_react.default.createElement("span", {
              className: "tl-btn-dd-content-wrapper"
            }, this.props.iconPosition === 'left' && this.props.icon && /*#__PURE__*/_react.default.createElement("span", {
              className: ' tl-bd-icon-left'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon,
              className: iconColorCustom
            })), buttonText, this.props.iconPosition === 'right' && this.props.icon && /*#__PURE__*/_react.default.createElement("span", {
              className: ' tl-bd-icon-right'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon,
              className: iconColorCustom
            })), /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-dropdown-icon'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: 'icon-system-chevron-down',
              className: iconColorCustom + ' '
            })));
          } else if (this.props.type === 'dropdownButtonPg') {
            buttonInnerContent = this.props.icon ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttonText, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon tl-bd-icon-right'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              className: iconColorCustom + ' tl-bd-svg-right toggle-down',
              name: 'icon-system-chevron-up',
              attributes: {
                id: this.props.name + "-svg"
              }
            }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttonText);
          } else if (this.props.iconPosition) {
            this.props.iconPosition === 'right' ? buttonInnerContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttonText, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon,
              className: iconColorCustom
            }))) : buttonInnerContent = this.getButtonContent(this.props.state, iconColorCustom, buttonText);
          } else if (this.props.icon) {
            buttonInnerContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon,
              className: iconColorCustom
            })), buttonText);
          } else {
            buttonInnerContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttonText, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon'
            }, /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon ? this.props.icon : primaryIcon,
              className: iconColorCustom
            })));
          }
          break;
        case 'secondary':
          buttonInnerContent = buttonText;
          break;
        default:
          buttonInnerContent = buttonText;
      }
      return buttonInnerContent;
    }
  }, {
    key: "buttonRender",
    value: function buttonRender() {
      var buttonRender = this.createButton(this.getButtonInnerContent());
      return buttonRender;
    }
  }, {
    key: "getButtonContent",
    value: function getButtonContent(state, iconColorCustom, buttonText) {
      var buttonContent;
      switch (state) {
        case 'loading':
          {
            buttonContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon',
              style: {
                paddingLeft: '0px'
              }
            }, /*#__PURE__*/_react.default.createElement(_spinner.Spinner, {
              size: "tl-spinner-medium"
            })), /*#__PURE__*/_react.default.createElement("span", {
              className: "text-light tl-button-status-msg"
            }, this.props.ButtonStatusMsg));
            break;
          }
        case 'success':
          {
            buttonContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon'
            }, /*#__PURE__*/_react.default.createElement(_Alert.Alert, {
              name: "alert-inline-success",
              icon: "icon-system-tick-copy",
              iconClass: "tl-icon-generic",
              label: "",
              labelClass: "body16"
            })), /*#__PURE__*/_react.default.createElement("span", {
              className: "text-light tl-button-status-msg"
            }, this.props.ButtonStatusMsg));
            break;
          }
        default:
          {
            buttonContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
              className: 'tl-button-icon'
            }, " ", /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
              name: this.props.icon,
              className: iconColorCustom
            })), buttonText);
            break;
          }
      }
      return buttonContent;
    }
  }, {
    key: "getButtonClass",
    value: function getButtonClass() {
      var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'super';
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'active';
      var buttonClass = '';
      if (state === 'disabled' || this.props.disabled) {
        buttonClass = 'tl-button-' + variant + '-disabled';
      } else if (state === 'loading') {
        buttonClass = 'tl-button-' + variant + '-' + state;
      } else if (state === 'success') {
        buttonClass = 'tl-button-' + variant + '-' + state;
      } else if (variant === 'secondary') {
        var buttonType = state === 'app' ? 'warning' : 'active';
        buttonClass = 'tl-button-' + variant + '-' + buttonType;
      } else if (state === 'warning') {
        buttonClass = 'tl-button-' + variant + '-' + state;
      } else {
        buttonClass = 'tl-button-' + variant + '-active';
      }
      if (this.props.className) {
        buttonClass += ' ' + this.props.className;
      }
      if (this.props.size) {
        buttonClass += ' tl-button-' + this.props.size;
      }
      if (this.props.type === 'dropdown' && this.props.dropDownState) {
        buttonClass += ' tl-button-dropdown-state tl-button-dropdown-state-' + this.props.dropDownState;
      }
      return buttonClass;
    }
  }, {
    key: "getButton",
    value: function getButton() {
      var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'super';
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'active';
      var buttonClass;
      var stateVal = this.props.state ? this.props.state : 'active';
      if (variant === 'super') {
        buttonClass = this.getButtonClass('super', stateVal);
      } else if (variant === 'primary') {
        buttonClass = this.getButtonClass('primary', stateVal);
        if (this.props.iconPosition) {
          buttonClass += this.props.iconPosition === 'right' ? ' tl-button-primary-icon-custom-right ' : ' tl-button-primary-icon-left ';
        } else if (this.props.type === "dropdownButton" || this.props.type === "dropdownButtonPg") {
          buttonClass += ' tl-button-primary-icon-left ';
        } else {
          buttonClass += ' tl-button-primary-icon-right ';
        }
      } else if (variant === 'secondary') {
        buttonClass = this.getButtonClass('secondary', stateVal);
      } else if (variant === 'emphasis') {
        buttonClass = this.getButtonClass('emphasis', stateVal);
        buttonClass += this.state.smallScreenClass ? ' ' + this.state.smallScreenClass : '';
      }
      buttonClass = 'tl-ui ' + buttonClass;
      return buttonClass;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.buttonRender());
    }
  }]);
  return Button;
}(_react.default.Component);
_defineProperty(Button, "defaultProps", void 0);
Button.defaultProps = defaultProps;